var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'text')?_c('th',{class:_vm.cls[_vm.type],style:({..._vm.colorStyle, fontSize: _vm.fontSize, fontWeight: _vm.fontWeight}),attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.value))]):_c('td',{class:_vm.cls[_vm.type],style:({..._vm.colorStyle, fontSize: _vm.fontSize, fontWeight: _vm.fontWeight})},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }